import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { useTranslation } from 'app/lang';
import { SearchParam } from 'app/widgets/PromocodeForm/constants';

import dictionary from './PromocodeLinkItem.dictionary.json';

import styles from './PromocodeLinkItem.module.scss';

type PromocodeLinkItemProps = {
  onClick?: VoidFunction;
};

const PromocodeLinkItem: FC<PromocodeLinkItemProps> = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Link to = {{ pathname: '/personal/gifts', search: SearchParam.PROMO }}
          onClick={onClick}
          data-ga-event="header-cabinet"
          data-ga-event-value="enterPromocode"
          className={styles.promoLink}>
      {t(dictionary.label)}
    </Link>
  );
};


export default PromocodeLinkItem;
